import axios from './http'
import originAxios from 'axios'

axios.CancelToken = originAxios.CancelToken

/**
 * @description 普通的接口请求
 * @method none
 * @param {data} 上传数据
 * @param {config} 上传数据配置
 *    @url url配置
 *    @fields 需上传的字段
 * @param {header} 请求头
 * @param {_this}  传过来的组件this
 */
const pure = {
  // 普通的pure get
  async get({ data, config }) {
    const url = config.url
    // 需上传的对象整理
    const upload = {}
    config.fields &&
      config.fields.forEach((item) => {
        if (
          data[item] === undefined ||
          data[item] === null ||
          (typeof data[item] === 'string' && !data[item])
        ) {
          return false
        }
        upload[item] = data[item]
      })
    return await axios.get(url, {
      params: upload,
    })
  },
  // 普通的pure get
  async getExcel({ data, config, headers, responseType }) {
    const url = config.url
    // 需上传的对象整理
    const upload = {}
    config.fields &&
      config.fields.forEach((item) => {
        if (
          data[item] === undefined ||
          data[item] === null ||
          (typeof data[item] === 'string' && !data[item])
        ) {
          return false
        }
        upload[item] = data[item]
      })
    if (responseType) {
      headers['Content-Type'] =
        'application/json; application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
    return await axios.get(url, {
      params: upload,
      headers: headers,
      responseType: 'arraybuffer',
    })
  },
  // 普通的pure get
  async getPdf({ data, config, headers, responseType }) {
    const url = config.url
    // 需上传的对象整理
    const upload = {}
    config.fields &&
      config.fields.forEach((item) => {
        if (
          data[item] === undefined ||
          data[item] === null ||
          (typeof data[item] === 'string' && !data[item])
        ) {
          return false
        }
        upload[item] = data[item]
      })
    if (responseType) {
      headers['Content-Type'] = 'application/json; application/octet-stream'
    }
    return await axios.get(url, {
      params: upload,
      headers: headers,
      responseType: responseType,
    })
  },
  // 普通的pure post
  async post({ data, config, headers, _this }) {
    // 新增有headers和cancelToken
    // 修改仅有cancelToken
    // 删除时若传入数组，第二个参数仅是一个数组而已，非对象形式
    const url = config.url
    // 需上传的对象整理，第二个参数
    let upload = {}
    config.fields &&
      config.fields.forEach((item) => {
        if (data[item] === undefined || data[item] === null) {
          return false
        }
        upload[item] = data[item]
      })
    // 第三个参数请求头整理：包括停止二次点击
    const CancelToken = axios.CancelToken
    const header = Object.assign({}, headers)
    if (_this.urlToken) {
      header.headers['Url-Token'] = _this.urlToken
    }
    // eslint不能访问原型，所以可用call的方式
    if (Object.prototype.hasOwnProperty.call(_this, 'cancelAxios')) {
      header.CancelToken = new CancelToken(function executor(c) {
        _this.cancelAxios = c
      })
    }
    if (data.ids) {
      upload = data.ids
    }
    return await axios.post(url, upload, header)
  },
  // application/x-www-form-urlencoded 的pure post
  async postByFormUrl({ data, config, headers, _this }) {
    // 新增有headers和cancelToken
    // 修改仅有cancelToken
    // 删除时若传入数组，第二个参数仅是一个数组而已，非对象形式
    const url = config.url
    // 需上传的对象整理，第二个参数
    const upload = {}
    config.fields &&
      config.fields.forEach((item) => {
        if (data[item] === undefined || data[item] === null) {
          return false
        }
        upload[item] = data[item]
      })

    let formUrlencodedData = new URLSearchParams()
    Object.keys(upload).forEach((key) => {
      formUrlencodedData.append(key, upload[key])
    })
    // 第三个参数请求头整理：包括停止二次点击
    const CancelToken = axios.CancelToken
    const header = Object.assign({}, headers)
    if (_this.urlToken) {
      header.headers['Url-Token'] = _this.urlToken
    }
    // eslint不能访问原型，所以可用call的方式
    if (Object.prototype.hasOwnProperty.call(_this, 'cancelAxios')) {
      header.CancelToken = new CancelToken(function executor(c) {
        _this.cancelAxios = c
      })
    }
    if (data.ids) {
      formUrlencodedData = data.ids
    }
    return await axios.post(url, formUrlencodedData, header)
  },
  // 普通的pure post
  async postPdf({ data, config, headers, _this, responseType }) {
    // 新增有headers和cancelToken
    // 修改仅有cancelToken
    // 删除时若传入数组，第二个参数仅是一个数组而已，非对象形式
    const url = config.url
    // 需上传的对象整理，第二个参数
    let upload = {}
    config.fields &&
      config.fields.forEach((item) => {
        if (data[item] === undefined || data[item] === null) {
          return false
        }
        upload[item] = data[item]
      })
    // 第三个参数请求头整理：包括停止二次点击
    const CancelToken = axios.CancelToken
    const header = Object.assign({}, headers)
    if (_this.urlToken) {
      header.headers['Url-Token'] = _this.urlToken
    }
    // eslint不能访问原型，所以可用call的方式
    if (Object.prototype.hasOwnProperty.call(_this, 'cancelAxios')) {
      header.CancelToken = new CancelToken(function executor(c) {
        _this.cancelAxios = c
      })
    }
    if (data.ids) {
      upload = data.ids
    }
    if (responseType) {
      header['Content-Type'] = 'application/json; application/octet-stream'
    }
    return await axios.post(url, upload, {
      headers: header,
      responseType: 'blob',
    })
    // return await originAxios({
    //   url: 'http://gateway.orgs-test-sitircompany.ant.andeancat.test.sitir.net' + url,
    //   data: upload,
    //   headers: header,
    //   method: 'post',
    //   responseType: 'blob'
    // })
  },
}

export default pure
